import CustomCardCustomerPolicy from "../../Components/custom-paper/CustomCardCustomerPolicy";
import Icon1 from '../../Assets/Images/Frame1.png';
import _ from "lodash";
import { t } from "i18next";
import '../../Assets/Styles/Customer/customer-policy-info.css'
import ImageBackground from '../../Assets/Images/background-contnt.png'
import CustomerPolicyInfoTable from "./cus-policy-info-table";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import * as CustomerService from '../../Services/customer-service';
import LoadingOverlay from "react-loading-overlay-nextgen";
import CustomNav from "../../Components/custom-nav/CustomNav";
import '../../Assets/Styles/Customer/customer-info.css';
import useWindowDimensions from "../../Layouts/useWindowDimension";
import FooterCustomer from "../../Layouts/footer/FooterCustomer";
import { useNavigate } from "react-router-dom";
import { countTimeExpired, moneyFormat } from "../../Services/service";
import '../../Assets/Styles/Customer/font-size.css'
import TableDialog from "../../Components/custom-table/TableDialog";
import CustomButtonPolicyInfoCustomer from "../../Components/custom-button/CustomButtonPolicyInfoCustomer";
export default function CustomerPolicyInfo() {
    const [objectDto, setObjectDto] = useState(localStorage.getItem("aaa") !== null ? JSON.parse(localStorage.getItem("aaa")) : null);
    const { height, width } = useWindowDimensions();
    const [activeItem, setActiveItem] = useState({ title: t("policycustomer"), icon: <i class="fa fa-file-text" aria-hidden="true"></i>, content: "", no: 1 });
    let url = window.location.toString();
    countTimeExpired(objectDto, setObjectDto);
    let params = url?.split("/");
    const poNumber = params[4];
    const { i18n } = useTranslation();
    const [info, setInfo] = useState(null);
    const [openAgent, setOpenAgent] = useState(false);
    const navigation = useNavigate();
    const divStyle = {
        backgroundImage: `url(${ImageBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100vw',
        height: height,
        backgroundRepeat: 'no-repeat'
    };
    if (objectDto === null) navigation('/');
    useEffect(() => {
    }, [i18n]);
    useEffect(() => {
        if (info === null) CustomerService.getPolicyDetailByPoNumber(poNumber, setObjectDto, setInfo);
    }, []);
    if (info === "") navigation('/danh-sach-hop-dong');
    return (
        <>
            <div className='nav-container' style={{ height: height }}>
                <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectDto} setObjectDto={setObjectDto} width={width} height={height} />
                <div className="customer-info-container" style={divStyle}>
                    {
                        info !== null && info !== "" ?
                            <div className="container-cus-policy-info">
                                <div className='header-cus-policy-info header-title-customer'> {/* Header + icon Header */}
                                    <div className='col-md-9'><span>{t("customerpolicynumber") + info.poNumber}</span>
                                        <p className="description-small-customer">Số hồ sơ: <span style={{ fontWeight: "bolder" }}>{info.applicationNumber}</span></p>
                                    </div>
                                    <div className='col-md-3 col-end'>
                                        <a className='a-cus-policy-info description-small-customer' style={{ marginRight: "5%" }} onClick={() => {
                                            setInfo(null);
                                            navigation("/danh-sach-hop-dong")
                                        }}>{t("return")}</a>
                                    </div>
                                </div>
                                <div className='body-cus-policy-info'>
                                    <div className="row-cus-policy-info">
                                        <div className="col-md-4 column-cus-policy-info">
                                            <CustomCardCustomerPolicy value={info.strSumAssured !== undefined && info.strSumAssured !== null ? moneyFormat(info.strSumAssured) : 0} Icon={Icon1} title={"Số tiền bảo hiểm sản phẩm chính (VNĐ)"} />
                                        </div>
                                        {/* <div className="col-md-3 column-cus-policy-info">
                                                <CustomCardCustomerPolicy value={policy.repay} Icon={Icon2} title={"Giá trị hoàn lại (VNĐ)"} />
                                            </div>
                                            <div className="col-md-3 column-cus-policy-info">
                                                <CustomCardCustomerPolicy value={policy.accountbalance} Icon={Icon3} title={"Giá trị tài khoản"} />
                                            </div> */}
                                    </div>
                                </div>
                                <div className='body-cus-policy-info' style={{ padding: "1% 1% 0% 1%", margin: 0 }}>
                                    <div className="row-cus-policy-info">
                                        <div className='col-md-9'>
                                            <div className='description-large-customer' style={{ fontWeight: "bold" }}>Thông tin hợp đồng</div>
                                        </div>
                                    </div>
                                </div>
                                <CustomerPolicyInfoTable policy={info} />
                                <div className="description-small-customer" style={{ paddingBottom: "5px" }}>
                                    {/* <CustomButtonPolicyInfoCustomer title={"Quyền lợi tiền mặt định kỳ"} /> */}
                                    <CustomButtonPolicyInfoCustomer title={"Đại lý phục vụ hợp đồng"} onClick={() => setOpenAgent(true)} />
                                </div>
                                <TableDialog isOpen={openAgent} setIsOpen={setOpenAgent} policy={info} />
                            </div>
                            :
                            <LoadingOverlay className="loading_overlay_content_customer" active={true} spinner text={t("loading")} />
                    }
                </div>
            </div>
            <FooterCustomer />
        </>
    )
};
